<template>
  <div id="BrandModel">
    <div v-if="component !== 3">
      <validation-provider v-slot="{ errors }" name="brand" @input="repeatBrand">
        <v-autocomplete
          :items="brand"
          v-model="brandnow"
          :error-messages="errors"
          :maxlength="100"
          :no-data-text="$t('label.no_results')"
          label="Marca"
          
        >
          <template v-slot:append-outer>
            <v-icon color="info" @click="dialogBrand = true">
              mdi-plus-circle-outline
            </v-icon>
          </template>
        </v-autocomplete>
      </validation-provider>
    </div>

    <v-card v-if="component === 3">
      <v-card-title class="custom-title">Marcas Asignadas</v-card-title> 
        <v-container fluid>
          <v-row>
            <v-col cols="30">
              <v-chip-group column>
                <v-chip text-color="black" class="v-chip--disabled" v-for="item in filteredBrands()" :key="item" medium disabled>
                  {{ item }}
                </v-chip>
                <v-icon color="info" @click="dialogBrand = true">
                  mdi-plus-circle-outline
                </v-icon>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-container>
    </v-card>
  
    <v-dialog v-model="dialogBrand" persistent max-width="400px">
      <v-card>
        <v-card-title class="text-center justify-center">
          Nueva marca 
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  @input="repeatBrand(),repeatBrand2()"
                  clearable
                  :alert="alert"
                  v-model="newNameBrand"
                  :maxlength="100"
                  label="Marca"
                  persistent-hint
                  counter
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
            <AlertMessageComponent class="small" ref="alertMessageComponent" />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn btn-outline-success" color="green" outlined plain :disabled="this.warning" @click="savebrand">
            <i class="feather icon-save mr-1"></i>
            Guardar
          </v-btn>
          <v-btn class="btn btn-outline-danger" color="red" outlined plain @click="closeDialog">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ProductsRequest } from "@/core/request";
import { ValidationProvider } from "vee-validate";
import AlertMessageComponent from "@/common/message/AlertMessageComponent";

export default {
  name: 'BrandComponent',
  props: {
    itemsbrand: "",
    component:{
      type: Number,
      required: false,
      default:1
    },
    nuevoObjeto:[],
  },
  data() {
    return {
      dialogBrand: false, 
      selectedModel: null,
      warning: false,
      newNameBrand: "",
      newBrand: [],
      idBrand: "",
      brandnow: null,
      brand: [""],
      productEdit: "",
      productid:"",
      brandsByProduct:[""],
      //data:99,
      newBrands:[],
      nameBrand:""
     
    };
  },
  methods: {
   idbrandnow(){
      //console.log(this.brand);
      return this.brandnow
    },
    namebrand2() {
      if(this.brandnow!=null){
        console.log("hola")
        if((this.brand.length!==0 && this.brandnow!=null) || this.nameBrand!=""){  
          let nameBrand = this.brand.filter((element) => { //THIS.BRAND =THIS.ITEMS
          if (element.value == this.brandnow) {
            return element;
          }
        });
        //console.log(nameBrand[0].text);
        return nameBrand[0].text;
        }
      }
      else{
        if(this.nameBrand!=""){
          let nameBrand = this.brand.filter((element) => { //THIS.BRAND =THIS.ITEMS
            if (element.value == this.brandnow) return element;
            this.nameBrand=''
          });
          return nameBrand[0].text;
        }
        else{
          return "N/A";
        }
      }
    },
    
    filteredBrands() {
      if (this.nuevoObjeto !== undefined) {
        
        this.newBrands=this.nuevoObjeto
        
        return this.brandsByProduct=this.nuevoObjeto.map(item => item.nameBrand); 
      }
      else {
        return ["Sin resultados"]
      }  
    },
    async listbrand(){
       //console.log(this.localAction);
       await ProductsRequest.listAllBrand()
          .then((res) => {
            let { data, success } = res.data.data;
            if (success) {
              this.brand = data;
            } else {
              this.brand = [];
              this.$refs.alertMessageComponent.reloadComponent(message);
            }
          })
          .catch((error) => {
            console.log(error);
            
            //this.alert("internal");
          })
          .finally(() => {
            this.sending = false;
            this.brandnow=null;
            //console.log(this.sub);
          });
    },
    async returnIdProduct( idProduct ) {
      //console.log("1 - "+idProduct);
      await ProductsRequest.brandbyid({ "idProduct": idProduct })
        .then((res) => {
          let { data } = res.data.data;
          this.brand = data;
          console.log(this.itemsbrand);
          console.log(this.brand);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.sending = false;
          this.brandnow=null;
        });
    },
    async listBrandsEditProd() {
      await ProductsRequest.brandbyid({ "idProduct": this.productEdit })
        .then((res) => {
          let { data } = res.data.data;
          this.brand = data;
          console.log(this.brand);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    async reloadComponent(id, idBrand) {
      this.productEdit=id
      this.brandnow = idBrand;
      this.brandnow =String(this.brandnow);
      //console.log(this.brandnow);
      this.listBrandsEditProd()
    },
    returData() {
      if(this.brand.length!==0 && this.brandnow!=null){
      let idBrand = this.brand.filter((element) => { //THIS.BRAND =THIS.ITEMS
        if (element.value == this.brandnow) return element;
      });
      return idBrand[0].value;
    }
    else{
      return null;
    }
    },
    namebrand() {
      if(this.brandnow!=null){
        if((this.brand.length!==0 && this.brandnow!=null)){
        let nameBrand = this.brand.filter((element) => { //THIS.BRAND =THIS.ITEMS
          if (element.value == this.brandnow) return element;
        });
        return nameBrand[0].text;
      }
      }  
    else{
      if(this.nameBrand!="" && this.nameBrand!=undefined){
        //console.log(this.nameBrand)
          let nameBrand = this.brand.filter((element) => { //THIS.BRAND =THIS.ITEMS
            if (element.value == this.brandnow) return element;
            this.nameBrand=''
          });
          return nameBrand[0].text;
        }
        else{
          
          return "N/A";
        }
    }
    },
    async savebrand() {
      let brand_all = {
        nameBrand: this.newNameBrand,
      };
      ProductsRequest.listAllBrand(brand_all).then((res) => {
        let { data } = res.data; 
        let { message, success } = data;
        if (success) {
          this.newBrand = [{ "value": null, "text": this.newNameBrand.toUpperCase() }];
          this.brand.unshift({ "value": null, "text": this.newNameBrand.toUpperCase() });
          this.newBrands.unshift({ "idBrand": null, "nameBrand": this.newNameBrand.toUpperCase() });
          this.nameBrand = this.newNameBrand;
          //console.log(this.newNameBrand);
          //this.data--
          //console.log(this.data);
          //console.log(this.newBrands);
          this.$emit('update:newNameBrand',this.newBrands)
        } else {
          this.alert("error", message);
        }
      })
      .catch((error) => {
        console.log(error);
        this.alert("internal");
      })
      .finally(() => {
        this.sending = false;
        this.dialogBrand = false;
        this.newNameBrand = "";
        this.brandnow = null;
        //console.log(this.brandnow);
        //console.log(this.nameBrand);
        
      });
    },
    alert(type, message) {
      this.$refs.alertMessageComponent.reloadComponent(type, message);
    },
    async repeatBrand() {
      this.warning = false;
      for (var item = 0; item < this.brand.length; item++) {
        var text = this.brand[item].text;
        if (text == this.newNameBrand.replace(/\s/g, '').toUpperCase()) {
          this.alert("MARCA", "La marca ya está registrada");
          this.warning = true;
        }
      }
    },
    async repeatBrand2() {
      this.warning = false;
      //console.log(this.brand);
      for (var item = 0; item < this.newBrands.length; item++) {
        var text = this.newBrands[item].nameBrand;
        if (text == this.newNameBrand.replace(/\s/g, '').toUpperCase()) {
          this.alert("MARCA", "La marca ya está registrada");
          this.warning = true;
        }
      }
    },
    async closeDialog() {
      this.dialogBrand = false;
      this.newNameBrand = "";
    },
  },
  created() {
    this.brandnow=1
  },
  mounted() {
    if(this.nuevoObjeto!=null){
      this.brandnow = "0";
      this.brand=["Sin resultados"]
    } 
  },
  components: {
    AlertMessageComponent
  },
};
</script>

<style scoped>
.btn-outline-danger {
  border-color: #ff3f3f !important;
  color: #ff3f3f !important;
}
.btn-outline-danger:hover {
  background-color: #ff3f3f !important;
  color: white !important;
}
.btn-outline-success {
  border-color: #037550 !important;
  color: #037550 !important;
}
.btn-outline-success:hover {
  background-color: #037550 !important;
  color: white !important;
}
.custom-title {
  position: absolute;
  color: #263a5b;
  top: -30px; 
  left: 0;
  right: 0;
  text-align: center;
  justify-content: center;
  font-weight: bold;
  font-size: 15px;
  background-color: rgb(255, 255, 255); 
}
.v-chip--disabled {
  opacity: 60;
  color:rgb(12, 12, 12);
  border-color: rgb(143, 6, 6);
  background-color: aqua;
  cursor: not-allowed;
}
</style>
